// extracted by mini-css-extract-plugin
export default {"rodape":"Rodape_rodape__F2Y75","barra":"Rodape_barra__EuNnK","redes":"Rodape_redes__P4Ntv","direitos":"Rodape_direitos__jHUBR"};